import { CHANGE_ORDER } from "../types";

const initState = {
  orderId: "",
};

const orderReducers = (state = initState, action) => {
  switch (action.type) {
    case CHANGE_ORDER:
      return {
        ...state,
        orderId: action.payload,
      };

    default:
      return state;
  }
};

export default orderReducers;
